import NotFound from '../../components/notFound/notFound';
const NotFoundView = NotFound;
export default NotFoundView;



// WEBPACK FOOTER //
// ./src/views/notFoundView/notFoundView.js